export default __webpack_public_path__ + "static/media/coldchain-warning.4e1a3071.svg";